import type { Cart } from '@ab-core/graphql/dist';
import { GET_MY_REWARD_SHOP_CART } from '@ab-core/hooks-v2/cart/gql/getMyRewardShopCart';
import { toast } from '@ab-core/toast';
import type { MutationFunctionOptions } from '@apollo/client';
import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import { REMOVE_CUSTOM_LINE_ITEMS, REMOVE_LINE_ITEMS } from './deleteLineItem';

type DeleteFromCartType = {
    success: boolean;
    error: boolean;
    errorMessage?: string;
    pending: boolean;
    response?: Cart;
    deleteFromCart: (options?: MutationFunctionOptions) => void;
};

const DeleteFromCart = (cartId?: string, lineItemIds?: string[], customLineItem = false): DeleteFromCartType => {
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [response, setResponse] = useState(undefined);
    const [pending, setPending] = useState(false);
    const [deleteFromCart, { loading }] = useMutation(customLineItem ? REMOVE_CUSTOM_LINE_ITEMS : REMOVE_LINE_ITEMS, {
        variables: {
            cartId,
            lineItemIds
        },
        update: () => {
            setSuccess(false);
            setErrorMessage('');
            setError(false);
        },
        onCompleted: (res) => {
            toast.success('Artikel entfernt');
            setResponse(res);
            setSuccess(true);
            setPending(false);
        },
        onError: (err) => {
            setErrorMessage(err.message);
            setError(true);
            setPending(false);
        },
        refetchQueries: [GET_MY_REWARD_SHOP_CART]
    });
    useEffect(() => {
        if (loading === true) {
            setPending(true);
            setSuccess(false);
            setError(false);
        }
    }, [loading]);

    return {
        deleteFromCart,
        success,
        error,
        response,
        errorMessage,
        pending
    };
};

export default DeleteFromCart;
